module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Fagus/Tokyo_Fagus_HadGEM2_RCP85_Mid.png";